import { DeleteOutlined, EditOutlined, EyeOutlined, HistoryOutlined, UnorderedListOutlined, InboxOutlined, CloseOutlined, PrinterOutlined, FilePdfOutlined, FileExcelOutlined, PlusCircleOutlined, ThunderboltOutlined, SyncOutlined, WarningOutlined, LockOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Form, Image, Modal, notification, Pagination, Popconfirm, Row, Select, Space, Spin, Tooltip, Upload, Input, Table, message, Collapse } from 'antd';
import HTTPService from '../../../utils/makerequest';
import { IPageData } from '../../../interfaces/page-data';
import { useEffect, useRef, useState } from 'react';
import { StateLoader } from '../../../redux/StateLoader';
import { IAuthentication, UserRole } from '../../../interfaces/authentication';
import { Toast } from 'primereact/toast';
import { IDropdownItem } from '../../../AltisComponent/AltisDataGrid';
import '../PrinterManagement/Device.css';
import { useTranslation } from 'react-i18next';
import { IInventory } from '../../../interfaces/IItemData';
import { IPrinterData } from '../../../interfaces/IPrinterData';
import { ITemplatesName } from '../../../interfaces/ITemplateName';
import i18n from '../../../i18n';
import * as XLSX from 'xlsx';
import { API_URL } from '../../../utils/Constants';
import { BulkUpdateModal } from './ModalClass/BulkUpdateModal';
import { IFilterOptions } from '../../../interfaces/IFilterOptions';
import MUIDatagrid, { IMUIDataGridColumns } from '../../../AltisComponent/MUIDataGrid';
import FaultRecordModal from './ModalClass/FaultRecordModal';


const InventoryManagement: React.FunctionComponent<any> = (props) => {
  const { onSetPage } = props;
  const { t } = useTranslation();
  const toast = useRef<any>(null);
  const loader = new StateLoader();
  const userInfo: IAuthentication = loader.loadAuthState();
  const [inventoryData, setInventoryData] = useState<IInventory>();
  const [templateData, setTemplateData] = useState<ITemplatesName[]>();
  const [printerData, setPrinterData] = useState<IPrinterData[]>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleExport, setIsModalVisibleExport] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [imageSrc, setImageSrc] = useState([]);
  const [isModalImage, setIsModalImage] = useState(false);
  const [isModalMovement, setIsModalMovement] = useState(false);
  const imagesPerPage = 1
  const [currentPage, setCurrentPage] = useState(1);
  const [movementData, setMovementData] = useState(null);
  const [detailData, setDetailData] = useState(null);
  const [isModalDetail, setIsModalDetail] = useState(false);
  const [inventoryId, setInventoryId] = useState(null);
  const [isModalVisibleImport, setIsModalVisibleImport] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedInventoryIds, setSelectedInventoryIds] = useState<number[]>([]);
  const [reader, setReader] = useState<string[][]>([]);
  const [selectedDropdown, setSelectedDropdown] = useState<string[]>([]);
  const [isModalVisibleBulk, setIsModalVisibleBulk] = useState(false);
  const [isModalVisibleFault, setIsModalVisibleFault] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    category: [],
    status: [],
    campus: [],
    locations: [],
    brand: [],
    supplier: [],
    type: [],
    department: [],
    actualLocation: [],
    locationStatus: []
  });

  const [filterOptions, setFilterOptions] = useState<IFilterOptions>({ brand: [], department: [], status: [], locations: [], category: [], supplier: [], campus: [], type: [], countReport: [] });

  const [grids, setGrids] = useState([
    {
      data: [],
      count: 0,
      columns: [],
    },
  ]);


  const [correctValues, setCorrectValues] = useState<any[]>([
    {
      id: 0,
      columnName: "Kampüs Adı",
      columnCorrectName: "Kampüs Adı",
      selectedValue: "Kampüs Adı",
      columnKey: "campusName"
    },
    {
      id: 1,
      columnName: "Konum Adı",
      columnCorrectName: "Konum Adı",
      selectedValue: "Konum Adı",
      columnKey: "locationName"
    },
    {
      id: 2,
      columnName: "Departman Adı",
      columnCorrectName: "Bölüm Adı",
      selectedValue: "Departman Adı",
      columnKey: "departmentName"
    },
    {
      id: 3,
      columnName: "Varlık Kategorisi",
      columnCorrectName: "Varlık Kategorisi",
      selectedValue: "Varlık Kategorisi",
      columnKey: "categoryName"
    },
    {
      id: 4,
      columnName: "Varlık Tipi",
      columnCorrectName: "Varlık Tipi",
      selectedValue: "Varlık Tipi",
      columnKey: "typeName"
    },
    {
      id: 5,
      columnName: "Tedarikçi Adı",
      columnCorrectName: "Tedarikçi Adı",
      selectedValue: "Tedarikçi Adı",
      columnKey: "supplierName"
    },
    {
      id: 6,
      columnName: "Durum",
      columnCorrectName: "Durum",
      selectedValue: "Durum",
      columnKey: "inventoryStatusName"
    },
    {
      id: 7,
      columnName: "Marka",
      columnCorrectName: "Marka",
      selectedValue: "Marka",
      columnKey: "brandName"
    },
    {
      id: 8,
      columnName: "Envanter Model Adı",
      columnCorrectName: "Envanter Model Adı",
      selectedValue: "Envanter Model Adı",
      columnKey: "inventoryName"
    },
    {
      id: 9,
      columnName: "Barkod",
      columnCorrectName: "Barkod",
      selectedValue: "Barkod",
      columnKey: "barcode",
      optional: true
    },
    {
      id: 10,
      columnName: "EPC",
      columnCorrectName: "EPC",
      selectedValue: "EPC",
      columnKey: "epc",
      optional: true
    },
    {
      id: 11,
      columnName: "NFC",
      columnCorrectName: "NFC",
      selectedValue: "NFC",
      columnKey: "nfc",
      optional: true
    },
    {
      id: 10,
      columnName: "Seri Numarası",
      columnCorrectName: "Seri Numarası",
      selectedValue: "Seri Numarası",
      columnKey: "serialNo",
      optional: true
    },
    {
      id: 11,
      columnName: "Referans Numarası",
      columnCorrectName: "Referans Numarası",
      selectedValue: "Referans Numarası",
      columnKey: "referanceNo",
      optional: true
    },
  ])

  const dataGridRef = useRef<any>(null);

  // useEffect(() => {
  //     InventoryFilter();
  //     const intervalId = setInterval(() => {
  //         if (dataGridRef.current) {
  //             dataGridRef.current.GetAllData();
  //         }
  //     }, 1000);
  //     return () => clearInterval(intervalId);
  // }, [])



  const pageData: IPageData = {
    title: t('item-management'),
    loaded: true,
  };

  const showModalBulk = () => {
    if (!selectedRows || selectedRows.length === 0) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('anyInventory'),
        life: 3000
      });
      return;
    }

    const distinctCompanyIds = Array.from(new Set(selectedRows.map(item => item.companyId)));

    if (distinctCompanyIds.length > 0) {
      setIsModalVisibleBulk(true);
    } else if (distinctCompanyIds.length === 0) {
      setIsModalVisibleBulk(false);
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('anyInventory'),
        life: 3000
      });
    } else {
      setIsModalVisibleBulk(false);
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('sameCompany'),
        life: 3000
      });
    }
  };

  const showModalFault = () => {
    if (!selectedRows || selectedRows.length === 0) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('anyInventory'),
        life: 3000
      });
      return;
    }

    if (selectedRows.length > 1) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('select_only_one_inventory'),
        life: 3000
      });
      return;
    }

    const selectedInventory = selectedRows[0];

    if (selectedInventory) {
      setIsModalVisibleFault(true);
      setSelectedInventoryIds([selectedInventory.inventoryId]);
    } else {
      setIsModalVisibleFault(false);
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('inventory_not_found'),
        life: 3000
      });
    }
  };

  const handleCancelBulk = () => {
    setIsModalVisibleBulk(false);
  };


  const handleCancelFault = () => {
    setIsModalVisibleFault(false);
  };

  useEffect(() => {
    dataGridRef.current.GetAllData();
  }, [selectedFilters])


  useEffect(() => {
    onSetPage(pageData);
    InventoryReportFilter();
  }, [i18n.language]);

  const paginatedImages = () => {
    if (!Array.isArray(imageSrc)) {
      return []; // Return an empty array if imageSrc is not an array
    }
    const startIndex = (currentPage - 1) * imagesPerPage;
    const endIndex = Math.min(startIndex + imagesPerPage, imageSrc.length);
    return imageSrc.slice(startIndex, endIndex);
  };

  const totalPages = Math.ceil((imageSrc?.length || 0) / imagesPerPage);

  const generatePagination = () => {
    const pages = [];
    const showPages = 3;

    if (totalPages <= showPages * 2 + 1) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      for (let i = 1; i <= showPages; i++) {
        pages.push(i);
      }
      if (currentPage > showPages + 2) {
        pages.push('...');
      }
      const startPage = Math.max(1, totalPages - showPages + 1);
      for (let i = startPage; i <= totalPages; i++) {
        pages.push(i);
      }
    }

    return pages;
  };

  const ImagePreview = async (id) => {
    HTTPService.GET(`/Inventory/pictureByInventory?inventoryId=${id}`).then(res => {
      if (res.status == 200) {

        setImageSrc(res.data);
        setIsModalImage(true);
      }
      else {
        console.error("asdas");
      }
    })
      .catch((error) => {
        console.error('Error fetching images:', error);
      })
  };


  const MovementPreview = (e?) => {
    var inventoryIdTmp = e?.inventoryId;

    if (inventoryIdTmp === null || inventoryIdTmp === undefined) {
      inventoryIdTmp = inventoryId
    } else {
      setInventoryId(inventoryIdTmp)
    }

    const body = {
      pageSize: e?.pageSize ?? 10,
      page: e?.page ?? 1,
      inventoryId: inventoryIdTmp,
      updatedDate: e?.updatedDate,
      inventoryTracking: e?.inventoryTracking,
      oldRecord: e?.oldRecord,
      newRecord: e?.newRecord
    }


    HTTPService.POST(`/InventoryTracking/InventoryTracking`, body).then((response) => {
      if (!response.data) {
        return;
      }
      if (response.status === 200) {
        setMovementData(response.data);
        setIsModalMovement(true);
      } else {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(response.data),
          life: 3000
        });
      }
    });
  };

  const DetailPreview = async (id) => {
    if (typeof id !== 'number') {
      console.error('Invalid ID:', id);
      return;
    }
    try {
      const response = await HTTPService.GET(`/Inventory/inventoryDetails?id=${id}`);
      setDetailData(response.data);
      setIsModalDetail(true);
    } catch (error) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('errorFetchingData'),
        life: 3000
      });
    }
  };


  const PDFPriview = async (values) => {
    setIsLoading(true)
    const printInventoryBarcode = selectedRows.map(row => row.customBarcode || row.barcode);

    const body = {
      templateId: values.selectTemplate,
      barcode: printInventoryBarcode
    };

    HTTPService.POSTblob(`/Inventory/pdfpreview`, body)
      .then((response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('pdfSuccess'),
            life: 3000
          });
          setIsModalVisibleExport(false);
        } else if (response.status === 452) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('licenceExpiredDate'),
            life: 3000
          });
        }
        else if (response.status === 453) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('licenceNotfound'),
            life: 3000
          });
        } else if (response.status != 450) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
      })
      .catch((err) => {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t('error'),
          life: 3000
        });
      }).finally(() => {
        setIsLoading(false)
      });
  };

  const AllTemplateName = (values) => {
    let companyIdToUse = values;
    HTTPService.GET(`/Template/allTemplateName?companyId=${companyIdToUse}`)
      .then((response) => {
        if (!response.data) {
          return;
        }
        let tmp: ITemplatesName[] = response.data;
        tmp.map((elem, index) => {
          elem['key'] = index;
        });
        setTemplateData(tmp);
      })
      .catch((error) => {
        console.error('Şablon çekme hatası:', error);
      });
  };


  const AllPrinterName = (values) => {
    let companyIdToUse = values;
    HTTPService.GET(`/Printer/allPrinterName?companyId=${companyIdToUse}`)
      .then((response) => {
        if (!response.data) {
          return;
        }
        let tmp: IPrinterData[] = response.data;
        tmp.map((elem, index) => {
          elem['key'] = index;
        });
        setPrinterData(tmp);
      })
      .catch((error) => {
        console.error('Cihaz çekme hatası:', error);
      });
  };

  const dropdownItemStatus: IDropdownItem[] = inventoryData?.statusData
    ? inventoryData.statusData.map((elem) => ({
      id: elem.inventoryStatusName,
      name: elem.inventoryStatusName,
    }))
    : [];

  const columns: IMUIDataGridColumns[] = [
    ...(userInfo.role == UserRole.AltisAdmin ? [{
      title: t('Company Name'),
      key: 'companyName',
      placeHolder: t('Company Name'),
      isSorting: true,
    }] : []),
    { title: t('inventoryName'), isSorting: true, headerAlign: 'center', align: 'left', key: 'inventoryName', placeHolder: t('inventoryName') },
    { title: t('barcode'), isSorting: true, key: 'customBarcode', placeHolder: t('barcode'), render: (text: string, record: any) => record.customBarcode || record.barcode },
    { title: t('item_type'), isSorting: true, key: 'typeName', placeHolder: t('item_type') },
    { title: t('item_group'), isSorting: true, key: 'categoryName', placeHolder: t('item_group'), },
    {
      title: t('location'),
      isSorting: true,
      key: 'locationName',
      placeHolder: t('actualLocation'),
      render: (text, record, index) => (
        <div>
          <span>{text}</span>
          {record.locationName !== record.actualLocationName && (
            <Tooltip title={record.actualLocationName}>
              <span style={{ color: 'red', marginLeft: 8, cursor: 'pointer' }}>⚠️</span>
            </Tooltip>
          )}
        </div>

      ),
    },
    //{ title: t('location'),   isSorting:true, key: 'actualLocationName', placeHolder: t('location'), inputType: 'input' },
    { title: t('inventory_status_name'), isSorting: true, key: 'inventoryStatusName', placeHolder: t('inventory_status_name'), dropdownItem: dropdownItemStatus },
    {
      title: t('isPrinted'),
      isSorting: false,
      key: 'isPrinted',
      dataType: 'checkbox',
      align: 'center',
      placeHolder: t('isPrinted'),
      render: (text, record) => (
        <Checkbox checked={record.isPrinted} disabled />
      )
    },
    ...(userInfo.role === UserRole.Personel || userInfo.role === UserRole.Operator ? [{
      title: t('debbit'), isSorting: true, key: 'debbit', placeHolder: t('debbit'),
    }] : []),
    ...(userInfo.role === UserRole.Personel || userInfo.role === UserRole.Operator ? [{
      title: t('responsible'), isSorting: true, key: 'responsible', placeHolder: t('responsible'),
    }] : []),
    {
      title: t('operations'),
      key: 'operations',
      placeHolder: t('Operations'),
      isSorting: false,
      width: 300,
      hideColumnMenu: true,
      render: (order, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
          <Space>
            <Popconfirm
              title={t('are_you_sure_inventory')}
              onConfirm={() => DeleteInventory(record.inventoryId)}
              okText={t('yes')}
              cancelText={t('no')}
            >
              <Tooltip title={t('delete')} placement="top">
                <Button
                  size='small'
                  icon={<DeleteOutlined />}
                  style={{ display: userInfo.role === UserRole.Personel ? 'none' : 'inline-block', width: '60px', borderRadius: '70px' }}
                  onClick={(e) => e.stopPropagation()}
                />
              </Tooltip>
            </Popconfirm>
            <Tooltip title={t('update')} placement="top">
              <Button
                size='small'
                icon={<EditOutlined />}
                style={{ display: userInfo.role === UserRole.Personel ? 'none' : 'inline-block', width: '60px', borderRadius: '70px' }}
                onClick={() => {
                  const inventoryId = record.inventoryId;
                  window.location.replace(`/admin/update-inventory/${inventoryId}`);
                }}
              />
            </Tooltip>
            <Tooltip title={t('preview')} placement="top">
              <Button
                size='small'
                icon={<EyeOutlined />}
                style={{ width: '60px', borderRadius: '70px' }}
                onClick={() => {
                  ImagePreview(record.inventoryId);
                }}
              />
            </Tooltip>
            {/* <Tooltip title={t('details')} placement="top">
              <Button
                size='small'
                icon={<UnorderedListOutlined />}
                style={{ width: '60px', borderRadius: '70px' }}
                onClick={() => {
                  DetailPreview(record.inventoryId);
                }}
              />
            </Tooltip> */}
            <Tooltip title={t('movements')} placement="top">
              <Button
                size='small'
                icon={<HistoryOutlined />}
                style={{ width: '60px', borderRadius: '70px' }}
                onClick={() => {
                  MovementPreview({ inventoryId: record.inventoryId })
                }}
              />
            </Tooltip>
          </Space>
        </div>
      ),
    },
  ];

  const dropdownItemType: IDropdownItem[] = [
    { id: 0, name: t('Debit') },
    { id: 1, name: t('Responsible') },
    { id: 2, name: t('Campus') },
    { id: 3, name: t('Location') },
    { id: 4, name: t('InventoryStatus') },
    { id: 5, name: t('Department') }
  ];


  const columns1: IMUIDataGridColumns[] = [
    {
      title: t('date'),
      key: 'updatedDate',
      width: 100,
      placeHolder: t('date'),
    },
    {
      title: t('movementType'),
      key: t('inventoryTracking'),
      width: 100,
      placeHolder: t('movementType'),
      enumValues: dropdownItemType,
      render: (value) => {
        return <div style={{ textAlign: 'center' }}>{t(value)}</div>;
      }
    },
    {
      title: t('oldRecord'),
      key: 'oldRecord',
      width: 100,
      placeHolder: t('oldRecord'),
    },
    {
      title: t('newRecord'),
      key: 'newRecord',
      width: 170,
      placeHolder: t('newRecord'),
    },
  ];

  const columns2: IMUIDataGridColumns[] = [
    {
      title: t('responsible'),
      key: 'inventoryResponsibleTBL',
      placeHolder: t('responsible'),
      render: (record) => {

        const responsibleInfo = record[0];

        if (responsibleInfo && responsibleInfo.responsibleUserTBL) {
          const user = responsibleInfo.responsibleUserTBL;
          return `${user.firstName} ${user.lastName}`;
        }
        return t('noResponsible');
      }
    },
    {
      title: t('debit'),
      key: 'debtUser',
      placeHolder: t('debit'),
      render: (record) => {

        const debitUser = record;

        if (debitUser) {
          return `${debitUser.firstName} ${debitUser.lastName}`;
        }
        return t('noDebit');
      }
    },
    {
      title: t('serial_no'),
      key: 'serialNo',
      placeHolder: t('serial_no'),
    },
    {
      title: t('Referance No'),
      key: 'referanceNo',
      placeHolder: t('Referance No'),
    },
  ];

  const columns3: IMUIDataGridColumns[] = [
    {
      title: t('excel_validation_errors'),
      key: 'errors',
      width: 600,
      render: (errors, record) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {errors.map((error, index) => {
            if (error.invalid[0] === "" && error.correct.length === 0) return null;

            const validValues = error.correct.filter(value => value !== null);

            return (
              <div key={index} style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <Input
                    style={{ width: '250px' }}
                    defaultValue={error.invalid[0] || t('empty_value')}
                    onChange={(e) => handleValueCorrection(error.field, e.target.value, record.row)}
                  />
                  <Select
                    style={{ width: '300px' }}
                    placeholder={t('select_valid_value')}
                    options={validValues.map(value => ({
                      label: value,
                      value: value
                    }))}
                    onChange={(value) => {
                      const input = document.querySelector(`input[data-field="${error.field}"][data-row="${record.row}"]`) as HTMLInputElement;
                      if (input) {
                        input.value = value;
                      }
                      handleValueCorrection(error.field, value, record.row);
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      ),
      placeHolder: '',
    }
  ];

  const formatErrorData = (invalidRows) => {
    return invalidRows.map(row => ({
      key: row.row.toString(),
      row: row.row,
      errors: row.errors
    }));
  };

  const handleConfirm = () => {
    excelDownload();
    setVisible(false);
  };

  const handleCancelExcel = () => {
    setVisible(false);
  };

  const InventoryFilter = (e?) => {
    const filters = e?.filters;
    const body = {
      pageSize: e?.pageSize,
      page: e?.page,
      ...filters,
      brand: selectedFilters?.brand,
      department: selectedFilters?.department,
      location: selectedFilters?.locations,
      campus: selectedFilters?.campus,
      status: selectedFilters?.status,
      category: selectedFilters?.category,
      supplier: selectedFilters?.supplier,
      type: selectedFilters?.type,
      locationStatus: selectedFilters?.locationStatus,
      //actualLocation:selectedFilters?.actualLocation
    };

    HTTPService.POST(`/Inventory/filters`, body).then((response) => {
      if (!response.data) {
        return;
      }
      if (response.status === 200) {
        setInventoryData(response.data);
      } else {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(response.data),
          life: 3000
        })
      }
    });
  };

  const clearFilters = () => {
    const initialFilters = {
      category: [],
      status: [],
      campus: [],
      locations: [],
      brand: [],
      supplier: [],
      type: [],
      department: [],
      actualLocation: [],
      locationStatus: []
    };

    setSelectedFilters(initialFilters);



  };

  const DeleteInventory = (id) => {
    HTTPService.DELETE(`/Inventory/deleteInventory?Id=${id}`).then((response) => {
      if (response.status === 200) {
        toast.current?.show({
          severity: 'success',
          summary: t('successful'),
          detail: t(response.data),
          life: 3000
        });
        dataGridRef.current.GetAllData()
      } else {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(response.data),
          life: 3000
        });
      }
    });
  };

  const handleDownload = () => {
    const currentLanguage = i18n.language;
    HTTPService.GETBlob(`/Inventory/inventoryExcelDownload?language=${currentLanguage}`)
      .then((response) => {
        if (response.status === 200) {
          //toast.success(t(response.data));
        } else if (response.status === 452) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('licenceExpiredDate'),
            life: 3000
          });
        }
        else if (response.status === 453) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('licenceNotfound'),
            life: 3000
          });
        }
        else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          })
        }
      });
  };

  const excelDownload = () => {
    if (selectedRows.length === 0) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('NoRows'),
        life: 3000
      })
      return;
    }

    const selectedData = selectedRows.map(row => ({
      inventoryName: row.inventoryName,
      barcode: row.customBarcode || row.barcode,
      typeName: row.typeName,
      categoryName: row.categoryName,
      locationName: row.locationName,
      departmentName: row.departmentName,
      supplierName: row.supplierName,
      brandName: row.brandName,
    }));

    HTTPService.POSTblobExcel('/Report/ExcelDownload', selectedData)
      .then((response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: (t('excelSuccess')),
            life: 3000
          })
        } else if (response.status === 452) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: (t('licenceExpiredDate')),
            life: 3000
          })
        } else if (response.status === 453) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: (t('licenceNotfound')),
            life: 3000
          })
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: (t(response.data)),
            life: 3000
          })
        }
      })
      .catch((err) => {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: (t('error')),
          life: 3000
        })
      });
  };

  const PrintData = (values) => {
    setIsLoading(true);

    const printInventoryBarcode = selectedRows.map(row => row.customBarcode || row.barcode);
    const companyId = selectedRows[0]?.companyId;
    var body = {
      printerId: values.selectPrinter,
      companyId: companyId,
      templateId: values.selectTemplate,
      printsBarcode: printInventoryBarcode
    };


    HTTPService.POST(`/Inventory/PrintInventory`, body)
      .then((response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: (t(response.data)),
            life: 3000
          })
        } else if (response.status === 452) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: (t(response.data)),
            life: 3000
          })
        } else if (response.status === 453) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: (t(response.data)),
            life: 3000
          })
        }
        else {
          // api timeouta düşüyor geçici olarak response.data kaldırılmıştır.
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: (t('printError')),
            life: 3000
          })
        }
      })
      .catch((response) => {
        console.error(response);
      })
      .finally(() => {
        setIsLoading(false); // Stop loading
        setIsModalVisible(false); // Hide modal
      });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  }

  const handleCancelExport = () => {
    setIsModalVisibleExport(false);
  }

  const handleCancelImage = () => {
    setIsModalImage(false);
  }

  const handleCancelMovement = () => {
    setIsModalMovement(false);
  }

  const handleCancelDetail = () => {
    setIsModalDetail(false);
  }

  const handleCancelImport = () => {
    setSelectedDropdown([])
    setIsModalVisibleImport(false);
  }

  const showModal = () => {
    if (!selectedRows || selectedRows.length === 0) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('anyInventory'),
        life: 3000
      });
      return;
    }

    const distinctCompanyIds = Array.from(new Set(selectedRows.map(item => item.companyId)));

    if (distinctCompanyIds.length > 1) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('sameCompany'),
        life: 3000
      });
      return;
    }

    setIsModalVisible(true);
    AllTemplateName(distinctCompanyIds[0]);
    AllPrinterName(distinctCompanyIds[0]);
  };

  const showModalExport = () => {
    if (!selectedRows || selectedRows.length === 0) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('anyInventory'),
        life: 3000
      });
      return;
    }

    const distinctCompanyIds = Array.from(new Set(selectedRows.map(item => item.companyId)));

    if (distinctCompanyIds.length > 1) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('sameCompany'),
        life: 3000
      });
      return;
    }

    setIsModalVisibleExport(true);
    AllTemplateName(distinctCompanyIds[0]);
  };

  const showModalImport = () => {
    setGrids([
      {
        data: [],
        count: 0,
        columns: [],
      },
    ]);
    setIsModalVisibleImport(true);
  };


  // const handleDropdownChange = (value, rowIndex, columnName) => {
  //   const updatedData = [...grids.data];
  //   updatedData[rowIndex][columnName] = value;
  //   setGrids((prevGrids) => ({
  //     ...prevGrids,
  //     data: updatedData,
  //   }));
  // };

  const handleDropdownChange = (value, id) => {
    if (value === 'Seçiniz') {
      return;
    }

    const selectedValues = correctValues.map((item) => item.selectedValue);

    if (selectedValues.includes(value)) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('excelDropdownError'),
        life: 3000
      });
      return;
    }

    setSelectedDropdown(prev => {
      return [...prev, value];
    });


    const newObj = [];
    correctValues.forEach((item) => {
      if (item.id === id) {
        item.selectedValue = value;
      }
      newObj.push({ ...item });
    });

    setCorrectValues(newObj);

  };



  const sendToAPI = (e) => {

    replaceExcel();


    const jsonData = reader.slice(1).map(row => {
      const jsonObject: { [key: string]: any } = {};

      reader[0].forEach((header, index) => {
        jsonObject[header] = row[index]?.toString();
      });

      // En az bir değer geçerliyse nesneyi döndür, aksi halde null
      const hasValidValue = Object.values(jsonObject).some(
        value => value !== undefined && value !== null && value.toString().trim() !== ""
      );

      return hasValidValue ? jsonObject : null;
    }).filter(item => item !== null);

    const isMatch = jsonData.every(item =>
      correctValues.every(a => {
        if (a.optional) return true;

        return a.columnKey in item;
      })
    );

    if (isMatch) {
      HTTPService.POST(`/Inventory/multipleInventories?companyId=${userInfo?.companyId}`, jsonData, {}, 200000)
        .then((response) => {
          if (response.status === 200) {
            setIsModalVisibleImport(false)
            window.location.reload()
            InventoryFilter();
          } else {
            toast.current?.show({
              severity: 'error',
              summary: t('mistake'),
              detail: t(response.data),
              life: 3000
            });
          }
        })
        .catch((error) => {
          console.error("API request failed:", error);
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: "API request failed",
            life: 3000
          });
        });
    } else {
      notification.error({
        message: t('excelColumnMismatchError'),
        description: t('excelColumnMismatchError'),
      });
    }
  };



  const handleExcelUpload = (info) => {
    const { status, originFileObj } = info.file;

    if (status === 'error') {
      console.error('Upload failed');
      return;
    }

    try {
      if (originFileObj) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'binary' });

          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];

          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 }) as string[][];

          setReader(jsonData);

          if (jsonData.length > 0) {

            const data = correctValues.map((row, index) => ({
              key: index,
              excelVerisi: row.columnName,
              dogruDeger: row.columnName,
            }));

            const firstRow = jsonData[0];

            const columnHeaders = ["Doğru Değer", "Excel Verisi"];

            const columns = columnHeaders.map((header, index) => ({
              title: header,
              key: header,
              render: (text, record, rowIndex) => {
                if (header === "Excel Verisi") {
                  const matchedValue = firstRow.find((value) => value.toLowerCase() === record.dogruDeger.toLowerCase());
                  const defaultValue = matchedValue != null ? matchedValue : "Seçiniz";
                  if (!selectedDropdown.includes(defaultValue)) {
                    setSelectedDropdown((prev) => [defaultValue]);
                  }
                  return (
                    <Select
                      defaultValue={defaultValue}
                      style={{ width: '100%' }}
                      onChange={(value) => handleDropdownChange(value || defaultValue, record.key)}
                    >
                      {firstRow.map((option, index) => (
                        <Select.Option key={index} value={option}
                        >
                          {option}
                        </Select.Option>
                      ))}
                    </Select>
                  );
                } else {
                  return (
                    <Input
                      defaultValue={correctValues[rowIndex].columnName}
                      style={{ width: '100%' }}
                      readOnly
                    />
                  );
                }
              },
            }));


            setGrids([
              {
                data: data,
                count: jsonData.length - 1,
                columns: columns,
              },
            ]);

          } else {
            console.error('Excel file is empty');
          }
        };

        reader.onerror = () => {
          console.error('Error reading the file');
        };

        reader.readAsBinaryString(originFileObj);
      }
    } catch (error) {
      console.error('Error processing Excel file:', error);
    }
  };

  const replaceExcel = () => {
    const currentHeaders = reader[0];  // İlk satırdaki başlıkları al

    // Header'ları, correctValues'taki columnKey ile eşleştir
    const updatedHeaders = currentHeaders?.map(header => {
      // header'ı correctValues içindeki selectedValue ile eşleştirip columnKey'i al
      const matchingItem = correctValues.find(item => item.selectedValue === header);
      return matchingItem ? matchingItem.columnKey : header;  // Eşleşme varsa columnKey, yoksa header'ı bırak
    });

    // updatedHeaders ile reader[0]'ı güncelle
    reader[0] = updatedHeaders;

    // JSON objelerini oluştur
    const jsonData = reader.slice(1).map(row => {
      const jsonObject: { [key: string]: any } = {};

      // Satırdaki her değeri updatedHeaders ile eşleştirip jsonObject'e ekle
      row.forEach((value, index) => {
        const columnKey = updatedHeaders[index];
        jsonObject[columnKey] = value;
      });

      // correctValues içindeki columnKey'lere göre eksik alanları doldur
      correctValues.forEach((item) => {
        const columnKey = item.columnKey;
        // Eğer jsonObject'te o key yoksa veya değeri boşsa, varsayılan değerini ata
        if (!jsonObject.hasOwnProperty(columnKey) || jsonObject[columnKey] === "") {
          jsonObject[columnKey] = item.columnName || "Seçiniz";  // "Seçiniz" varsayılan değeri
        }
      });

      return jsonObject;
    });

    setReader(reader);  // reader'ı güncelle
  };

  const handleValueCorrection = (field: string, newValue: string, rowNumber: number) => {
  };

  const handleRowSelection = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setSelectedIds(newSelection.map(row => row.inventoryId));
  };


  const handleDelete = () => {
    if (!selectedRows || selectedRows.length === 0) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('anyInventory'),
        life: 3000
      });
      return;
    }

    const selectedInventoryIds = selectedRows.map(row => row.inventoryId);
    const distinctCompanyIds = Array.from(new Set(selectedRows.map(row => row.companyId)));

    if (distinctCompanyIds.length > 1) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('sameCompany'),
        life: 3000
      });
      return;
    }

    HTTPService.DELETE(`/Inventory/multipleDeleteInventories`, selectedInventoryIds)
      .then((response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t(response.data),
            life: 3000
          });
          setSelectedRows([]);
          dataGridRef.current.GetAllData();
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
      })
      .catch(error => {
        console.error("Delete Error:", error);
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t('deleteError'),
          life: 3000
        });
      });
  };

  const refreshDataGrid = () => {
    InventoryFilter();
  };

  const InventoryReportFilter = (e?) => {
    const body = {
      category: e?.category,
      campus: e?.campus,
      type: e?.type
    };

    HTTPService.POST(`Report/postfilters`, body).then((response) => {

      if (response.status === 200) {
        setFilterOptions(response.data);
      } else if (response.status === 400) {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(response.data),
          life: 3000
        });
      }
      else {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(response.data),
          life: 3000
        });
      }
    });
  };

  const handleFilterGroupChange = (filterKey, values) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [filterKey]: values,
    }));
  };


  const handleFilterChange = (filterType: keyof typeof selectedFilters, id: number) => {
    const newSelectedFilters = {
      ...selectedFilters,
      [filterType]: selectedFilters[filterType].includes(id)
        ? selectedFilters[filterType].filter(item => item !== id)
        : [...selectedFilters[filterType], id]
    };

    setSelectedFilters(newSelectedFilters);

    if (filterType === 'category') {
      InventoryReportFilter({ category: newSelectedFilters.category });
    }

    if (filterType === 'campus') {
      InventoryReportFilter({ campus: newSelectedFilters.campus });
    }
  };

  const modifiedInventoryData = inventoryData?.data.map(item => ({
    ...item,
    total: inventoryData.total,
  }));


  return (
    <>
      <Toast ref={toast} />
      <Row gutter={16} align="middle" style={{ marginBottom: '20px' }}>

        <Col
          xs={24}
          sm={userInfo?.role === UserRole.AltisAdmin ? 8 : 12}
          md={userInfo?.role === UserRole.AltisAdmin ? 8 : 12}
          lg={userInfo?.role === UserRole.AltisAdmin ? 6 : 8}
          xl={userInfo?.role === UserRole.AltisAdmin ? 6 : 8}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'nowrap' }}>
            <Tooltip title={t('print')}>
              <Button
                type="primary"
                shape="circle"
                onClick={showModal}
                hidden={userInfo.role === UserRole.Personel}
                style={{
                  width: 'auto',
                  height: 64,
                  backgroundColor: 'transparent',
                  color: '#1890ff',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 0,
                  border: 'none',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                  e.currentTarget.style.color = '#40a9ff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.color = '#1890ff';
                }}
                size="middle"
              >
                <PrinterOutlined style={{ fontSize: 24 }} />
                <span style={{ fontSize: '12px', marginTop: '4px' }}>{t('print')}</span>
              </Button>
            </Tooltip>

            <Tooltip title={t('pdf_label')}>
              <Button
                type="primary"
                onClick={showModalExport}
                hidden={userInfo.role === UserRole.Personel}
                style={{
                  width: 'auto',
                  height: 64,
                  backgroundColor: 'transparent',
                  color: '#1890ff',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginLeft: '20px',
                  padding: 0,
                  border: 'none',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                  e.currentTarget.style.color = '#40a9ff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.color = '#1890ff';
                }}
                size="middle"
              >
                <FilePdfOutlined style={{ fontSize: 24 }} />
                <span style={{ fontSize: '12px', marginTop: '4px' }}>{t('pdf_label_msg')}</span>
              </Button>
            </Tooltip>

            <Tooltip title={t('excel_file_asset')}>
              <Button
                onClick={showModalImport}
                hidden={userInfo.role === UserRole.Personel}
                style={{
                  width: 'auto',
                  height: 64,
                  backgroundColor: 'transparent',
                  color: '#1890ff',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginLeft: '20px',
                  padding: 0,
                  border: 'none',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                  e.currentTarget.style.color = '#40a9ff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.color = '#1890ff';
                }}
              >
                <FileExcelOutlined style={{ fontSize: 24 }} />
                <span style={{ fontSize: '12px', marginTop: '4px' }}>{t('excel_file_asset_msg')}</span>
              </Button>
            </Tooltip>

            <Tooltip title={t('report_export')}>
              <Popconfirm
                title={`${selectedRows.length} ${t('excel_download_message')}`}
                visible={visible}
                onConfirm={handleConfirm}
                onCancel={handleCancelExcel}
                okText="Evet"
                cancelText="Hayır"
              >
                <Button
                  shape="circle"
                  onClick={() => setVisible(true)}
                  hidden={userInfo.role === UserRole.Personel}
                  style={{
                    width: 'auto',
                    height: 64,
                    backgroundColor: 'transparent',
                    color: '#1890ff',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginLeft: '40px',
                    padding: 0,
                    border: 'none',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                    e.currentTarget.style.color = '#40a9ff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = 'none';
                    e.currentTarget.style.color = '#1890ff';
                  }}
                >
                  <FileExcelOutlined style={{ fontSize: 24 }} />
                  <span style={{ fontSize: '12px', marginTop: '4px' }}>{t('report_export')}</span>
                </Button>
              </Popconfirm>
            </Tooltip>

            <Tooltip title={t('add_new_item')}>
              <Button
                shape="circle"
                onClick={() => window.location.replace('/admin/add-inventory')}
                hidden={userInfo.role === UserRole.Personel}
                style={{
                  width: 'auto',
                  height: 64,
                  backgroundColor: 'transparent',
                  color: '#1890ff',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginLeft: '40px',
                  padding: 0,
                  border: 'none',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                  e.currentTarget.style.color = '#40a9ff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.color = '#1890ff';
                }}
              >
                <PlusCircleOutlined style={{ fontSize: 24 }} />
                <span style={{ fontSize: '12px', marginTop: '4px' }}>{t('add_new_item')}</span>
              </Button>
            </Tooltip>

            <Tooltip title={t('add_new_item_speed')}>
              <Button
                shape="circle"
                onClick={() => window.location.replace('/admin/add-inventory-quick')}
                hidden={userInfo.role === UserRole.Personel}
                style={{
                  width: 'auto',
                  height: 64,
                  backgroundColor: 'transparent',
                  color: '#1890ff',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginLeft: '40px',
                  padding: 0,
                  border: 'none',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                  e.currentTarget.style.color = '#40a9ff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.color = '#1890ff';
                }}
              >
                <ThunderboltOutlined style={{ fontSize: 24 }} />
                <span style={{ fontSize: '12px', marginTop: '4px' }}>{t('quick_add')}</span>
              </Button>
            </Tooltip>

            <BulkUpdateModal
              isModalVisibleBulk={isModalVisibleBulk}
              setIsModalVisibleBulk={setIsModalVisibleBulk}
              handleCancelBulk={handleCancelBulk}
              inventoryId={selectedIds}
              t={t}
              datagridref={dataGridRef}
            />
          </div>

        </Col>
      </Row>

      <Modal
        title={t('Template Printing')}
        visible={isModalVisible}
        onCancel={handleCancel}
        width={800}
        footer={null}
      >
        <div style={{ padding: '20px' }}>
          <Spin spinning={isLoading}>
            <Form onFinish={PrintData}>
              <Row gutter={16}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item
                    label={t('select_template')}
                    name='selectTemplate'
                    rules={[
                      {
                        required: true,
                        message: t('please_select_template'),
                      },
                    ]}
                    style={{ marginBottom: '16px' }} // Adjusted margin
                  >
                    <Select
                      key='selectTemplateUpload'
                      style={{ width: '100%' }} // Ensure full width
                    >
                      {templateData?.map((item) => (
                        <Select.Option key={item.templateId} value={item.templateId}>
                          {item.templateName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item
                    label={t('select_printer')}
                    name='selectPrinter'
                    rules={[
                      {
                        required: true,
                        message: t('please_select_printer'),
                      },
                    ]}
                    style={{ marginBottom: '16px' }}
                  >
                    <Select
                      key='selectPrinterUpload'
                      className='custom-select'
                      style={{ width: '100%' }}
                    >
                      {printerData?.map((item) => (
                        <Select.Option key={item.printerId} value={item.printerId}>
                          {item.printerName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    type='primary'
                    htmlType="submit"
                    shape='round'
                    size='middle'
                    style={{ width: 'auto', borderRadius: '10px', }}
                  >
                    {t('print')}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Spin>
        </div>
      </Modal>

      <FaultRecordModal
        isModalVisibleFault={isModalVisibleFault}
        inventoryData={modifiedInventoryData}
        inventoryFilter={InventoryFilter}
        selectedInventoryIds={selectedInventoryIds}
        userId={userInfo?.userId}
        handleCancelFault={handleCancelFault} />

      <Modal
        title={t('PDF Export')}
        visible={isModalVisibleExport}
        onCancel={handleCancelExport}
        width={800}
        footer={null}
      >
        <div style={{ padding: '20px' }}>
          <Spin spinning={isLoading}>
            <Form onFinish={PDFPriview}>
              <Row gutter={16}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item
                    label={t('select_template')}
                    name='selectTemplate'
                    rules={[
                      {
                        required: true,
                        message: t('please_select_template'),
                      },
                    ]}
                    style={{ marginBottom: '16px' }}
                  >
                    <Select
                      key='selectTemplateUpload'
                      style={{ width: '100%' }}
                    >
                      {templateData?.map((item) => (
                        <Select.Option key={item.templateId} value={item.templateId}>
                          {item.templateName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    type='primary'
                    htmlType="submit"
                    shape='round'
                    size='middle'
                    style={{ width: 'auto', borderRadius: '10px' }}
                  >
                    {t('PDF Export')}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Spin>
        </div>
      </Modal>

      <Modal
        title={<span style={{ fontWeight: 'bold' }}>{t('image_preview')}</span>}
        visible={isModalImage}
        onCancel={handleCancelImage}
        footer={null}
      >
        {imageSrc.length > 0 ? (
          <><div style={{ textAlign: 'center' }}>
            {paginatedImages().map((image, index) => (
              <Image
                key={image.pictureGuid}
                src={`${API_URL}/images/${image.pictureGuid}`}
                alt={`Resim ${index}`}
                width={350}
                height={350}
                preview={{
                  src: `${API_URL}/images/${image.pictureGuid}`,
                }}
                style={{ borderRadius: '4px' }}
              />
            ))}
          </div>

            {totalPages > 1 && (
              <Pagination
                current={currentPage}
                pageSize={imagesPerPage}
                total={imageSrc.length}
                onChange={page => setCurrentPage(page)}
                style={{ textAlign: 'center', marginTop: '16px' }}
                itemRender={(page, type, originalElement) => {
                  if (type === 'page') {
                    const pages = generatePagination();
                    if (pages.includes(page) || page.toString() === '...') {
                      return <span style={{ padding: '0 8px', cursor: 'pointer', fontWeight: currentPage === page ? 'bold' : 'normal' }}>{page}</span>;
                    }
                    return originalElement;
                  }
                  return originalElement;
                }}
              />
            )}
          </>
        ) : (
          <p style={{ textAlign: 'center' }}>{t('noImage')}</p>
        )}
      </Modal>

      <Modal
        title={<span style={{ fontWeight: 'bold' }}>{t('details')}</span>}
        visible={isModalDetail}
        onCancel={handleCancelDetail}
        footer={null}
      >
        <div style={{ textAlign: 'center' }}>
          {detailData ? (
            <>
              <MUIDatagrid
                data={detailData}
                total={detailData?.count}
                columns={columns2}
                onChange={DetailPreview}
              />
            </>
          ) : (
            <p>{t('loading')}</p>
          )}
        </div>
      </Modal>

      <Modal
        title={<span style={{ fontWeight: 'bold' }}>{t('movementTrace')}</span>}
        visible={isModalMovement}
        onCancel={handleCancelMovement}
        footer={null}
      >
        <div style={{ textAlign: 'center' }}>
          {movementData ? (
            <>
              <MUIDatagrid
                data={movementData?.data}
                total={movementData?.count}
                columns={columns1}
                onChange={(e) => {
                  MovementPreview({
                    ...e,
                    inventoryId: inventoryId,
                  });
                }}
              />
            </>
          ) : (
            <p>{t('loading')}</p>
          )}
        </div>
      </Modal>

      <Modal
        title={t('excel_file_upload')}
        visible={isModalVisibleImport}
        onCancel={handleCancelImport}
        width={800}
        footer={null}
      >
        <div style={{ padding: '20px' }}>
          <Spin spinning={isLoading}>
            <Form>
              <Row gutter={16}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Button
                    type='primary'
                    htmlType="submit"
                    shape='round'
                    size='middle'
                    onClick={handleDownload}
                    style={{ width: '100%', marginTop: '-45px', borderRadius: '10px' }}
                  >
                    {t('example_template_download')}
                  </Button>
                  <Upload.Dragger
                    name="file"
                    multiple={false}
                    accept=".xlsx,.xls"
                    onChange={(info) => {
                      const { status } = info.file;
                      if (status === 'done') {
                        handleExcelUpload(info);
                        notification.warning({
                          message: t('file_required_value'),
                          description: t('file_upload_description'),
                        });
                      }
                      else if (status === 'uploading') {

                      }
                    }}
                    customRequest={({ onSuccess }) => {
                      onSuccess("ok");
                      return true;
                    }}
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">{t('click_or_drag_file')}</p>
                    <p className="ant-upload-hint">{t('excel_file_upload')}</p>
                  </Upload.Dragger>
                </Col>


                <Col xs={24} style={{ marginTop: '55px', height: '300px' }}>
                  <div
                    style={{
                      border: '1px solid black',
                      borderRadius: '8px',
                      padding: '16px',
                      backgroundColor: 'white',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    <div style={{ flex: 1, overflowY: 'auto', marginBottom: '16px' }}>
                      <Table
                        dataSource={grids[0]?.data}  // Veriler
                        columns={grids[0]?.columns}  // Kolonlar
                        pagination={false}  // Sayfalama kullanmıyoruz
                        rowKey="key"  // Satırlara key eklememiz gerekebilir
                      />
                    </div>
                  </div>
                </Col>

                <Col xs={24} style={{ marginTop: '20px', textAlign: 'right' }}>
                  <Button
                    type='primary'
                    htmlType="submit"
                    shape='round'
                    size='middle'
                    style={{ width: 'auto', marginLeft: '10px', borderRadius: '10px' }}
                    onClick={sendToAPI}
                  >
                    {t('excel_allow')}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Spin>
        </div>
      </Modal>


      <Col xs={24} sm={10} md={24} lg={24} xl={24} style={{ paddingLeft: '8px' }}>
        <div style={{ display: 'flex', gap: '20px', overflowX: 'auto', paddingBottom: '20px', width: '100%' }}>
          <div style={{ marginBottom: '20px', minWidth: '250px' }}>
            <Form.Item>
              <strong><span>{t('category')} ({selectedFilters.category.length})</span></strong>
              <div className="checkbox-group-container" style={{ flex: '1 1 250px' }}>
                <Checkbox.Group
                  value={selectedFilters.category}
                  onChange={(values) => {
                    handleFilterGroupChange('category', values);
                  }}
                >
                  <div>
                    {filterOptions.category.sort((a, b) => a.categoryName.localeCompare(b.categoryName)).map((option) => (
                      <div key={option.categoryId}>
                        <Checkbox value={option.categoryId}>{option.categoryName}</Checkbox>
                      </div>
                    ))}
                  </div>
                </Checkbox.Group>
              </div>
            </Form.Item>
          </div>

          <div style={{ marginBottom: '20px', minWidth: '250px' }}>
            <Form.Item>
              <strong><span>{t('item_type')} ({selectedFilters.type.length})</span></strong>
              <div className="checkbox-group-container"
                style={{
                  width: '250px',
                  height: '200px',
                  overflowY: 'auto',
                  border: '1px solid #ddd',
                  padding: '10px',
                  boxSizing: 'border-box',
                  flex: '1 1 250px'
                }}>
                <Checkbox.Group
                  value={selectedFilters.type}
                  onChange={(values) => handleFilterGroupChange('type', values)}
                >
                  <div>
                    {filterOptions.type.sort((a, b) => a.typeName.localeCompare(b.typeName))
                      .filter((option) => selectedFilters.category.length === 0 || selectedFilters.category.includes(option.categoryId))
                      .map((option) => (
                        <div key={option.typeId}>
                          <Checkbox value={option.typeId}>{option.typeName}</Checkbox>
                        </div>
                      ))}
                  </div>
                </Checkbox.Group>
              </div>
            </Form.Item>
          </div>

          {/* Inventory Status Panel */}
          <div style={{ marginBottom: '20px', minWidth: '250px' }}>
            <Form.Item>
              <strong><span>{t('InventoryStatus')} ({selectedFilters.status.length})</span></strong>
              <div className="checkbox-group-container"
                style={{
                  width: '250px',
                  height: '200px',
                  overflowY: 'auto',
                  border: '1px solid #ddd',
                  padding: '10px',
                  boxSizing: 'border-box',
                  flex: '1 1 250px'
                }}>
                <div>
                </div>

                <Checkbox.Group
                  value={selectedFilters.status}
                  onChange={(values) => handleFilterGroupChange('status', values)}
                >
                  <div>
                    {filterOptions.status.sort((a, b) => a.inventoryStatusName.localeCompare(b.inventoryStatusName)).map((option) => (
                      <div key={option.inventoryStatusId}>
                        <Checkbox value={option.inventoryStatusId}>{option.inventoryStatusName}</Checkbox>
                      </div>
                    ))}
                  </div>
                </Checkbox.Group>
              </div>
            </Form.Item>
          </div>

          {/* Campus Panel */}
          <div style={{ marginBottom: '20px', minWidth: '250px' }}>
            <Form.Item>
              <strong><span>{t('campus')} ({selectedFilters.campus.length})</span></strong>
              <div className="checkbox-group-container"
                style={{
                  width: '250px',
                  height: '200px',
                  overflowY: 'auto',
                  border: '1px solid #ddd',
                  padding: '10px',
                  boxSizing: 'border-box',
                  flex: '1 1 250px'
                }}>
                <Checkbox.Group
                  value={selectedFilters.campus}
                  onChange={(values) => handleFilterGroupChange('campus', values)}
                >
                  <div>
                    {filterOptions.campus.sort((a, b) => a.campusName.localeCompare(b.campusName)).map((option) => (
                      <div key={option.campusId}>
                        <Checkbox value={option.campusId}>{option.campusName}</Checkbox>
                      </div>
                    ))}
                  </div>
                </Checkbox.Group>
              </div>
            </Form.Item>
          </div>

          {/* Actual Location Panel */}
          <div style={{ marginBottom: '20px', minWidth: '250px' }}>
            <Form.Item>
              <strong><span>{t('location')} ({selectedFilters.locations.length})</span></strong>
              <div className="checkbox-group-container"
                style={{
                  width: '250px',
                  height: '200px',
                  overflowY: 'auto',
                  border: '1px solid #ddd',
                  padding: '10px',
                  boxSizing: 'border-box',
                  flex: '1 1 250px'
                }}>
                <div>
                </div>

                <Checkbox.Group
                  value={selectedFilters.locations}
                  onChange={(values) => handleFilterGroupChange('locations', values)}
                >
                  <div>
                    {filterOptions.locations.sort((a, b) => a.locationName.localeCompare(b.locationName))
                      .filter((option) => !selectedFilters.campus.length || selectedFilters.campus.includes(option.campusId))
                      .map((option) => (
                        <div key={option.locationId}>
                          <Checkbox value={option.locationId}>{option.locationName}</Checkbox>
                        </div>
                      ))}
                  </div>
                </Checkbox.Group>
              </div>
            </Form.Item>
          </div>


          {/* Location Panel */}
          {/* <div style={{ marginBottom: '20px', minWidth: '250px'}}>
            <Form.Item>
            <strong><span>{t('location')} ({selectedFilters.actualLocation.length})</span></strong>
              <div className="checkbox-group-container"
                style={{
                  width: '250px', 
                  height: '200px',
                  overflowY: 'auto', 
                  border: '1px solid #ddd',
                  padding: '10px',
                  boxSizing: 'border-box',
                  flex: '1 1 250px'
                }}>
                <div>
                </div>

                <Checkbox.Group
                  value={selectedFilters.actualLocation}
                  onChange={(values) => handleFilterGroupChange('actualLocation', values)}
                >
                  <div>
                    {filterOptions.locations.sort((a, b) => a.locationName.localeCompare(b.locationName))
                      .filter((option) => !selectedFilters.campus.length || selectedFilters.campus.includes(option.campusId))
                      .map((option) => (
                        <div key={option.locationId}>
                          <Checkbox value={option.locationId}>{option.locationName}</Checkbox>
                        </div>
                      ))}
                  </div>
                </Checkbox.Group>
              </div>
            </Form.Item>
          </div> */}


          {/* Department Panel */}
          <div style={{ marginBottom: '20px', minWidth: '250px' }}>
            <Form.Item>
              <strong><span>{t('Department')} ({selectedFilters.department.length})</span></strong>
              <div className="checkbox-group-container"
                style={{
                  width: '250px',
                  height: '200px',
                  overflowY: 'auto',
                  border: '1px solid #ddd',
                  padding: '10px',
                  boxSizing: 'border-box',
                  flex: '1 1 250px'
                }}>
                <div>
                </div>

                <Checkbox.Group
                  value={selectedFilters.department}
                  onChange={(values) => handleFilterGroupChange('department', values)}
                >
                  <div>
                    {filterOptions.department.sort((a, b) => a.departmentName.localeCompare(b.departmentName)).map((option) => (
                      <div key={option.departmentId}>
                        <Checkbox value={option.departmentId}>{option.departmentName}</Checkbox>
                      </div>
                    ))}
                  </div>
                </Checkbox.Group>
              </div>
            </Form.Item>
          </div>

          {/* Brand Panel */}
          <div style={{ marginBottom: '20px', minWidth: '250px' }}>
            <Form.Item>
              <strong><span>{t('brand')} ({selectedFilters.brand.length})</span></strong>
              <div className="checkbox-group-container"
                style={{
                  width: '250px',
                  height: '200px',
                  overflowY: 'auto',
                  border: '1px solid #ddd',
                  padding: '10px',
                  boxSizing: 'border-box',
                  flex: '1 1 250px'
                }}>
                <div>
                </div>

                <Checkbox.Group
                  value={selectedFilters.brand}
                  onChange={(values) => handleFilterGroupChange('brand', values)}
                >
                  <div>
                    {filterOptions.brand.sort((a, b) => a.brandName.localeCompare(b.brandName)).map((option) => (
                      <div key={option.brandId}>
                        <Checkbox value={option.brandId}>{option.brandName}</Checkbox>
                      </div>
                    ))}
                  </div>
                </Checkbox.Group>
              </div>
            </Form.Item>
          </div>

          {/* Supplier Panel */}
          <div style={{ marginBottom: '20px', minWidth: '250px' }}>
            <Form.Item>
              <strong><span>{t('supplier')} ({selectedFilters.supplier.length})</span></strong>
              <div className="checkbox-group-container"
                style={{
                  width: '250px',
                  height: '200px',
                  overflowY: 'auto',
                  border: '1px solid #ddd',
                  padding: '10px',
                  boxSizing: 'border-box',
                  flex: '1 1 250px'
                }}>
                <div>
                </div>

                <Checkbox.Group
                  value={selectedFilters.supplier}
                  onChange={(values) => handleFilterGroupChange('supplier', values)}
                >
                  <div>
                    {filterOptions.supplier.sort((a, b) => a.supplierName.localeCompare(b.supplierName)).map((option) => (
                      <div key={option.supplierId}>
                        <Checkbox value={option.supplierId}>{option.supplierName}</Checkbox>
                      </div>
                    ))}
                  </div>
                </Checkbox.Group>
              </div>
            </Form.Item>
          </div>

          {/* Location Status */}
          <div style={{ marginBottom: '20px', minWidth: '250px' }}>
            <Form.Item>
              <strong><span>{t('locationStatus')} ({selectedFilters.locationStatus.length})</span></strong>
              <div className="checkbox-group-container"
                style={{
                  width: '250px',
                  height: '200px',
                  overflowY: 'auto',
                  border: '1px solid #ddd',
                  padding: '10px',
                  boxSizing: 'border-box',
                  flex: '1 1 250px'
                }}>
                <div>
                </div>

                <Checkbox.Group
                  onChange={(values) => handleFilterGroupChange('locationStatus', values)}
                >
                  <div>
                    <Checkbox value={1}>{t('locationChanged')}</Checkbox>
                  </div>
                  <div>
                    <Checkbox value={2}>{t('locationNotChanged')}</Checkbox>
                  </div>
                </Checkbox.Group>
              </div>
            </Form.Item>
          </div>


        </div>
      </Col>

      <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '5px', flexWrap: 'wrap', }}>
        <Tooltip title={t('noFilter')}>
          <Button
            shape="circle"
            onClick={clearFilters}
            hidden={userInfo.role === UserRole.Personel}
            style={{
              width: 64,
              height: 64,
              backgroundColor: 'transparent',
              color: '#1890ff',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 0,
              border: 'none',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
              e.currentTarget.style.color = '#40a9ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.color = '#1890ff';
            }}
          >
            <CloseOutlined style={{ fontSize: 24 }} />
          </Button>
        </Tooltip>

        <Tooltip title={t('bulk_update')}>
          <Button
            shape="circle"
            onClick={showModalBulk}
            hidden={userInfo.role === UserRole.Personel}
            style={{
              width: 64,
              height: 64,
              backgroundColor: 'transparent',
              color: '#1890ff',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '5px',
              padding: 0,
              border: 'none',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
              e.currentTarget.style.color = '#40a9ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.color = '#1890ff';
            }}
          >
            <SyncOutlined style={{ fontSize: 24 }} />
          </Button>
        </Tooltip>


        <Tooltip title={t('bulk_delete')}>
          <Popconfirm
            title={t('bulk_delete_message')}
            onConfirm={handleDelete}
            okText="Evet"
            cancelText="Hayır"
          >
            <Button
              shape="circle"
              style={{
                width: 64,
                height: 64,
                backgroundColor: 'transparent',
                color: '#1890ff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: '5px',
                padding: 0,
                border: 'none',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                e.currentTarget.style.color = '#40a9ff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.color = '#1890ff';
              }}
              size="middle"
              hidden={userInfo.role === UserRole.Personel}
            >
              <DeleteOutlined style={{ fontSize: 24 }} />
            </Button>
          </Popconfirm>
        </Tooltip>

        <Tooltip title={!userInfo.licencePackage?.isMaintenance && userInfo.role !== UserRole.AltisAdmin ? t('maintenanceModuleAuthorization') : t('fault_record')}>
          <Button
            shape="circle"
            onClick={showModalFault}
            disabled={userInfo.role !== UserRole.AltisAdmin ? !userInfo.licencePackage.isMaintenance : false}
            style={{
              width: 64,
              height: 64,
              backgroundColor: 'transparent',
              color: '#1890ff',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '5px',
              padding: 0,
              border: 'none',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
              e.currentTarget.style.color = '#40a9ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.color = '#1890ff';
            }}
            size="middle"
            hidden={userInfo.role === UserRole.Personel}
          >
            {!userInfo.licencePackage?.isMaintenance && userInfo.role !== UserRole.AltisAdmin ? <LockOutlined style={{ fontSize: 24 }} /> : <WarningOutlined style={{ fontSize: 24 }} />}
          </Button>
        </Tooltip>
      </div>

      <Row style={{ marginTop: '-15px' }}>
        <Col span={24}>
          <MUIDatagrid
            ref={dataGridRef}
            data={inventoryData?.data}
            total={inventoryData?.count}
            columns={columns}
            enableSelection={true}
            onSelectionChange={handleRowSelection}
            filterMode='server'
            onChange={InventoryFilter}
          />
        </Col>
      </Row>
    </>
  );
};

export default InventoryManagement;